import { string } from "yup";
import { TFunction } from "i18n";
import {
  MAX_COMPANY_NAME_LENGTH,
  MAX_COMPANY_WEBSITE_LENGTH,
  validationSchema,
} from "component-library/src/components/Organisms/ContactPerformerPopUp/validationSchema";

export const agentContactValidationSchema = (t: TFunction) => {
  const companyName = t("common:contactPerformerModal.companyName");
  const companyWebsiteSocialMedia = t(
    "common:contactPerformerModal.companyWebsiteSocialMedia"
  );
  const overrides = {
    companyName: string()
      .nullable()
      .max(
        MAX_COMPANY_NAME_LENGTH,
        t("common:validation.error.entryMaxLength", {
          fieldName: companyName,
          length: MAX_COMPANY_NAME_LENGTH,
        })
      )
      .required(
        t("common:validation.error.entryRequired", { fieldName: companyName })
      ),
    companyWebsite: string()
      .nullable()
      .max(
        MAX_COMPANY_WEBSITE_LENGTH,
        t("common:validation.error.entryMaxLength", {
          fieldName: companyWebsiteSocialMedia,
          length: MAX_COMPANY_WEBSITE_LENGTH,
        })
      )
      .required(
        t("common:validation.error.entryRequired", {
          fieldName: companyWebsiteSocialMedia,
        })
      ),
  };

  return validationSchema(t, overrides);
};
